import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className="not-found">
            <h1>404</h1>
            <h2>SORRY!! The Page you are looking for is not valid</h2>
        </div>
    );
};

export default NotFound;